export const obtenerFechaRendimientos = () => {
    const hora = 12 // 12 del medio dia

    let fecha = new Date(new Date().getTime() + 1000 * 60 * 60 * 24)

    let fechaRendimientos = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora, 0, 0)

    return fechaRendimientos

}